import { PUBLIC_ENVIRONMENT } from '$env/static/public';
import { FIREBASE_AUTH_DOMAIN } from '$lib/siteConfig';
import { getApp, getApps, initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// From https://firebase.google.com/docs/projects/api-keys:
// Usually, you need to fastidiously guard API keys
// (for example, by using a vault service or setting the keys as environment variables);
// however, API keys for Firebase services are ok to
// include in code or checked-in config files.

const localFirebaseConfig = {
	apiKey: 'AIzaSyCOQkk8IxXIWDw5uYMWmjt_oi6L-kFibJ4',
	// authDomain: 'voltaic-nebula-360300.firebaseapp.com',
	authDomain: FIREBASE_AUTH_DOMAIN,
	projectId: 'voltaic-nebula-360300',
	storageBucket: 'voltaic-nebula-360300.appspot.com',
	messagingSenderId: '114296571634',
	appId: '1:114296571634:web:91bcf4de406b051ac3b26b',
	measurementId: 'G-MXYYXYG1L3'
};

const prodFirebaseConfig = {
	apiKey: 'AIzaSyC5fbUS4U9VGQqVhRbCn82qbIv4-fQAfM0',
	// authDomain: 'iliad-production.firebaseapp.com',
	// Site-keyed production domain. Development uses the corresponding
	// auth-dev hostname. Each environment keeps one shared Firebase project and
	// user pool across its two sites (design/DOMAIN_SPLIT.md, "Auth identity
	// surfaces").
	authDomain: FIREBASE_AUTH_DOMAIN,
	projectId: 'iliad-production',
	storageBucket: 'iliad-production.appspot.com',
	messagingSenderId: '820767175720',
	appId: '1:820767175720:web:721fa6907446e63001f11d',
	measurementId: 'G-FEDT22RSME'
};

const firebaseConfig =
	PUBLIC_ENVIRONMENT === 'prod'
		? prodFirebaseConfig
		: PUBLIC_ENVIRONMENT === 'local' || PUBLIC_ENVIRONMENT === 'dev'
			? localFirebaseConfig
			: undefined;

if (firebaseConfig == undefined) {
	throw new Error('No firebase config for environment: ' + PUBLIC_ENVIRONMENT);
}

// Vite can re-evaluate this module during hot reload. Reuse the default app so
// a config edit does not make the running dev server fail with app/duplicate-app.
export const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth();
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
	prompt: 'select_account'
});
